import React from 'react'
import '../../css/Account/Account.css'
import { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ForgotPassword from './ForgotPassword';
import { AuthContext } from '../../Context/AuthProvider';

const Login = ({setAuthType}) => {
  const API = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [isOpen,setIsOpen]=useState(false);
  const {setUser} = useContext(AuthContext);
  const {message,setMessage}=useState('');
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/login`, { email, password });
            localStorage.setItem("token", response.data.token);
            setUser(response.data.account);
            navigate('/');
    } catch (error) {
      setMessage(error.response.data.message); 
    }
  }
  
  return (
    <div className="login">
        <h1>Bejelentkezés</h1>
        <form action="">
            <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
            <input type="password" placeholder="Jelszó" value={password} onChange={(e) => setPassword(e.target.value)}/>
            <button onClick={handleSubmit}>Bejelentkezés</button>
            <p>{message}</p>
            <p onClick={() => setIsOpen(true)}>Elfelejtette jelszavát?</p>
        </form>
      {isOpen ? <ForgotPassword/> : <></>}
    </div>
  )
}

export default Login